/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {GanttItem} from './GanttItem';

class SpecialDate {
    date: Date;
    label: string;
    tooltip: string;
    constructor(date: Date, label: string) {
        this.date = date;
        this.label = label;
        this.tooltip = this.label + '\n' + this.days[this.date.getDay()] + '\n' + this.date.toLocaleDateString();
    }
    days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
}

export class GanttSection {
    public label: string;
    public ganttItems: GanttItem[] = [];
    public specialDates: SpecialDate[] = [];

    constructor(label: string) {
        this.label = label;
    }

    public addGanttItem(item: GanttItem) {
        // Add a date range to the list
        this.ganttItems.push(item);
    }

    public addDate(date: Date, label: string) {
        this.specialDates.push(new SpecialDate(date, label));
    }
}
